import { resolveGeoAttribution } from '@/utils/geo';
import { buildPublicApiUrl } from '@/utils/config';

function getTracker () {
    if (typeof window === 'undefined') {
        return null;
    }
    if (window._hmt && typeof window._hmt.push === 'function') {
        return window._hmt;
    }
    return null;
}

const GEO_VISITOR_KEY = 'dszh_geo_visitor_id';

function inferPageType (route) {
    if (!route || !route.path) {
        return 'unknown';
    }
    if (route.path === '/geo') {
        return 'geo-home';
    }
    if (route.path.indexOf('/geo/topic/') === 0) {
        return 'geo-topic';
    }
    if (route.path.indexOf('/go/') === 0) {
        return 'geo-go';
    }
    return 'site';
}

function getGeoVisitorKey () {
    if (typeof window === 'undefined') {
        return '';
    }
    try {
        let key = window.localStorage.getItem(GEO_VISITOR_KEY);
        if (!key) {
            key = typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID().replace(/-/g, '') : `${Date.now()}${Math.random().toString(16).slice(2)}`;
            window.localStorage.setItem(GEO_VISITOR_KEY, key);
        }
        return key;
    } catch (err) {
        return `${Date.now()}${Math.random().toString(16).slice(2)}`;
    }
}

function postGeoEvent (route, eventType, payload = {}, extra = {}) {
    if (typeof window === 'undefined') {
        return;
    }
    const endpoint = buildPublicApiUrl('/Geo/collect');
    const formData = new FormData();
    const merged = {
        event_type: eventType,
        source_key: payload.source || payload.source_key || 'direct',
        source_label: payload.source_label || payload.source || '',
        campaign: payload.campaign || '',
        content: payload.content || 'faq',
        page_type: inferPageType(route),
        page_path: route.fullPath || route.path || '/',
        page_title: document.title || '',
        entry_url: payload.entry_url || window.location.href,
        referrer_url: payload.referrer || document.referrer || '',
        question_id: payload.questionId || '',
        visitor_key: getGeoVisitorKey(),
        session_key: payload.session_key || '',
        target_label: extra.target_label || '',
        target_path: extra.target_path || '',
        model_key: payload.model_key || payload.model || '',
        model_label: payload.model_label || ''
    };
    Object.keys(merged).forEach(key => {
        if (merged[key] !== undefined && merged[key] !== null && merged[key] !== '') {
            formData.append(key, merged[key]);
        }
    });
    try {
        if (navigator.sendBeacon && navigator.sendBeacon(endpoint, formData)) {
            return;
        }
    } catch (err) {
        // ignore and fall back
    }
    fetch(endpoint, {
        method: 'POST',
        mode: 'no-cors',
        credentials: 'omit',
        body: formData,
        keepalive: true
    }).catch(() => {});
}

export function trackBaiduPageview (route) {
    const tracker = getTracker();
    if (!tracker || !route) {
        return;
    }
    tracker.push(['_trackPageview', route.fullPath || route.path || '/']);
}

export function syncGeoBaiduTracking (route, payloadOverride = null) {
    const tracker = getTracker();
    if (!tracker || !route) {
        return null;
    }
    const payload = payloadOverride || resolveGeoAttribution(route);
    const pageType = inferPageType(route);

    if (payload) {
        tracker.push(['_setCustomVar', 1, 'geo_source', payload.source_label || payload.source, 2]);
        tracker.push(['_setCustomVar', 2, 'geo_source_key', payload.source, 2]);
        tracker.push(['_setCustomVar', 3, 'geo_campaign', payload.campaign || 'unknown', 2]);
        tracker.push(['_setCustomVar', 4, 'geo_content', payload.content || 'faq', 2]);
        tracker.push(['_setCustomVar', 5, 'geo_page_type', pageType, 2]);
    }

    postGeoEvent(route, 'page_view', payload);
    if (pageType === 'geo-go' && payload) {
        tracker.push(['_trackEvent', 'geo', 'jump', [payload.source, payload.campaign || '', payload.content || 'faq'].join('|')]);
        postGeoEvent(route, 'jump', payload);
    }

    return payload;
}

export function recordGeoAction (route, eventType, payload = {}, extra = {}) {
    const tracker = getTracker();
    if (tracker && payload) {
        tracker.push(['_trackEvent', 'geo', eventType, [payload.source, payload.campaign || '', payload.content || 'faq'].join('|')]);
    }
    postGeoEvent(route, eventType, payload, extra);
    return payload;
}
